import RatingsLogo from './RatingsLogo'
export default RatingsLogo
